import * as React from 'react'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import { compose } from 'redux'
import { RootState } from 'src/core/redux/reducer'
import { connect } from 'react-redux'
import {submit, getFormValues, isValid} from 'redux-form'
import autobind from 'autobind-decorator'
import { withGlobalProgress } from 'src/shared/GlobalProgress'
import { withToast } from 'src/shared/Toast'
import { WithToast } from 'src/shared/Toast/Toast'
import { WithGlobalProgress } from 'src/type/lib/withGlobalProgress'
import { ExpensionStepProps } from 'src/shared/ExpensionStepper'
import { RouteComponentProps, withRouter } from 'react-router'
import { CircularProgress } from '@material-ui/core'
import TunnelActions from 'src/shared/TunnelActions/TunnelActions'
import { withCotationRequest, CtxCotationRequest } from '../CotationRequestProvider'

import CollarKIKOForm from 'src/shared/Cotation/form/CollarKIKOForm'
import AutocallRendementForm from 'src/shared/Cotation/form/AutocallRendementForm'
import WeddingCakeOptionsForm from 'src/shared/Cotation/form/WeddingCakeOptionsForm'
import TunnelAsymetriqueForm from 'src/shared/Cotation/form/TunnelAsymetriqueForm'
import TermeParticipatifAsymetriqueForm from 'src/shared/Cotation/form/TermeParticipatifAsymetriqueForm'
import TermeAsymetriqueForm from 'src/shared/Cotation/form/TermeAsymetriqueForm'
import TermeAsymetriqueDesactivantForm from 'src/shared/Cotation/form/TermeAsymetriqueDesactivantForm'
import TermeAccumulateurKOForm from 'src/shared/Cotation/form/TermeAccumulateurKOForm'
import TARFForm from 'src/shared/Cotation/form/TARFForm'
import WeddingCakeAccumulateurForm from 'src/shared/Cotation/form/WeddingCakeAccumulateurForm'
import CapForm from 'src/shared/Cotation/form/CapForm'
import SwapForm from 'src/shared/Cotation/form/SwapForm'
import CollarForm from 'src/shared/Cotation/form/CollarForm'
import SwapKOForm from 'src/shared/Cotation/form/SwapKOForm'
import CapKOForm from 'src/shared/Cotation/form/CapKOForm'
import CollarKOForm from 'src/shared/Cotation/form/CollarKOForm'
import DIYPlacementForm from 'src/shared/Cotation/form/DIYPlacementForm'
import DIYChangeForm from 'src/shared/Cotation/form/DIYChangeForm'
import TermeSecForm from 'src/shared/Cotation/form/TermeSecForm'
import { cotationGlobalControl } from 'src/shared/Cotation/form/GlobalCondition'


interface IProps extends WithI18n,
  WithGlobalProgress,
  WithToast,
  RouteComponentProps<any>,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props>, 
  ExpensionStepProps,
  CtxCotationRequest{
}

class CotationInfoStep extends React.Component<IProps, {}> {

  render() {
    const {formValues, isFormValid,  location, match, productSelected} = this.props
    const hasGlobalError = (productSelected && formValues) ? cotationGlobalControl(productSelected.product_type, formValues) : false;
    return (
        <>    
            {!match.url.includes("cotation-duplicate") && 
              <>
                {this.formRendering()}
              </>
            }
            {((location.state && location.state.duplicate) || match.url.includes("cotation-duplicate")) &&
              <>
                {this.formRenderingWithInitialValue()}
              </>
            }
            <TunnelActions
                {...this.props}
                isFirst={true}
                onClick={this.submitFormRemotely}
                canNext={isFormValid && !hasGlobalError}
            />
        </>
    )
  }

  @autobind
  private handleSubmitForm(values){
    this.props.updateDataProvider("formParams", values)
    if(this.props.next){
      this.props.next()
    }
  }

  @autobind
  private submitFormRemotely() {
    this.props.submitForm(submit(`${this.props.product.product_type}_form`));
  };

  @autobind
  private formRendering(){
    const {productSelected} = this.props
    if(productSelected){
      switch(productSelected.product_type){
        case 'COLLAR_KI_KO':
            return <CollarKIKOForm onSubmit={this.handleSubmitForm} />;
        case 'AUTOCALL_RENDEMENT':
            return <AutocallRendementForm onSubmit={this.handleSubmitForm} />;
        case 'WEDDING_CAKE_OPTIONS':
            return <WeddingCakeOptionsForm onSubmit={this.handleSubmitForm} />;
        case 'TUNNEL_ASYMETRIQUE':
            return <TunnelAsymetriqueForm onSubmit={this.handleSubmitForm} />;
        case 'TERME_PARTICIPATIF':
            return <TermeParticipatifAsymetriqueForm onSubmit={this.handleSubmitForm} />;
        case 'TERME_ASYMETRIQUE':
            return <TermeAsymetriqueForm onSubmit={this.handleSubmitForm} />;
        case 'TERME_ASYMETRIQUE_DESACTIVANT':
            return <TermeAsymetriqueDesactivantForm onSubmit={this.handleSubmitForm} />;
        case 'TERME_ACCUMULATEUR_KO':
            return <TermeAccumulateurKOForm onSubmit={this.handleSubmitForm} />;
        case 'TERME_SEC':
            return <TermeSecForm onSubmit={this.handleSubmitForm} />;
        case 'TARF':
            return <TARFForm onSubmit={this.handleSubmitForm} />;
        case 'WEDDING_CAKE_ACCUMULATEUR':
            return <WeddingCakeAccumulateurForm onSubmit={this.handleSubmitForm} />;
        case 'SWAP':
            return <SwapForm onSubmit={this.handleSubmitForm} />;
        case 'CAP':
            return <CapForm onSubmit={this.handleSubmitForm} />;
        case 'COLLAR':
            return <CollarForm onSubmit={this.handleSubmitForm} />;
        case 'SWAP_KO':
            return <SwapKOForm onSubmit={this.handleSubmitForm} />;
        case 'CAP_KO':
            return <CapKOForm onSubmit={this.handleSubmitForm} />;
        case 'COLLAR_KO':
            return <CollarKOForm onSubmit={this.handleSubmitForm} />;
        case 'DIY_PLACEMENT':
            return <DIYPlacementForm onSubmit={this.handleSubmitForm} />;
        case 'DIY_CHANGE':
            return <DIYChangeForm onSubmit={this.handleSubmitForm} />;
        default:
            return ''
      }
    } else {
      return <CircularProgress size={32}/>
    }
  }

  /*
    The component ExpensionStep always render before formParams updated, so we always get the form without initialValues.
    To be able to get the form with init value, we must separate 2 case and restrict the appearance's form until the formParams loaded
    This is not a good solution. TODO: improve it
  */
 @autobind
 private formRenderingWithInitialValue(){
   const {productSelected, formParams} = this.props
   if(productSelected !== undefined && formParams !== undefined){
     switch(productSelected.product_type){
       case 'COLLAR_KI_KO':
           return <CollarKIKOForm onSubmit={this.handleSubmitForm} initialValues={formParams} />;
       case 'AUTOCALL_RENDEMENT':
           return <AutocallRendementForm onSubmit={this.handleSubmitForm} initialValues={formParams} />;
       case 'WEDDING_CAKE_OPTIONS':
           return <WeddingCakeOptionsForm onSubmit={this.handleSubmitForm} initialValues={formParams}/>;
       case 'TUNNEL_ASYMETRIQUE':
           return <TunnelAsymetriqueForm onSubmit={this.handleSubmitForm} initialValues={formParams} />;
       case 'TERME_PARTICIPATIF':
           return <TermeParticipatifAsymetriqueForm onSubmit={this.handleSubmitForm} initialValues={formParams} />;
       case 'TERME_ASYMETRIQUE':
           return <TermeAsymetriqueForm onSubmit={this.handleSubmitForm} initialValues={formParams} />;
       case 'TERME_ASYMETRIQUE_DESACTIVANT':
           return <TermeAsymetriqueDesactivantForm onSubmit={this.handleSubmitForm} initialValues={formParams} />;
       case 'TERME_ACCUMULATEUR_KO':
           return <TermeAccumulateurKOForm onSubmit={this.handleSubmitForm} initialValues={formParams}/>;
       case 'TERME_SEC':
          return <TermeSecForm onSubmit={this.handleSubmitForm} initialValues={formParams}/>;
       case 'TARF':
           return <TARFForm onSubmit={this.handleSubmitForm} initialValues={formParams} />;
       case 'WEDDING_CAKE_ACCUMULATEUR':
           return <WeddingCakeAccumulateurForm onSubmit={this.handleSubmitForm} initialValues={formParams} />;
       case 'SWAP':
           return <SwapForm onSubmit={this.handleSubmitForm} initialValues={formParams} />;
       case 'CAP':
           return <CapForm onSubmit={this.handleSubmitForm} initialValues={formParams}/>;
       case 'COLLAR':
           return <CollarForm onSubmit={this.handleSubmitForm} initialValues={formParams} />;
       case 'SWAP_KO':
           return <SwapKOForm onSubmit={this.handleSubmitForm} initialValues={formParams} />;
       case 'CAP_KO':
           return <CapKOForm onSubmit={this.handleSubmitForm} initialValues={formParams} />;
       case 'COLLAR_KO':
           return <CollarKOForm onSubmit={this.handleSubmitForm} initialValues={formParams} />;
       case 'DIY_PLACEMENT':
           return <DIYPlacementForm onSubmit={this.handleSubmitForm} initialValues={formParams} />;
       case 'DIY_CHANGE':
           return <DIYChangeForm onSubmit={this.handleSubmitForm} initialValues={formParams} />;
       default:
           return ''
     }
   } else {
     return <CircularProgress size={32}/>
   }
 }
  
}

const state2props = (state: RootState) =>  ({
    product: state.productDetail.entity,
    isFormValid: isValid(`${state.utils.cotationProductSelected.product_type}_form`)(state),
    formValues: getFormValues(`${state.utils.cotationProductSelected.product_type}_form`)(state),
})

const dispatch2props = (dispatch: any) => ({
    submitForm: (handerSubmit) => dispatch(handerSubmit)
})

export default compose(
    withI18n,
    withGlobalProgress,
    withRouter,
    withToast,
    withCotationRequest,
    connect(state2props, dispatch2props),
)(CotationInfoStep)



// WEBPACK FOOTER //
// ./src/page/Consumer/Product/cotation/step/CotationInfoStep.tsx